import React from 'react'

import Button from '@mui/material/Button'

import { Beat } from '../../../types/CommonBeat'

export interface InsightButtonProps {
  beat: Pick<Beat, 'call_to_action' | 'guid' | 'supporting_action'>
  disabled?: boolean
  hide?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  primary?: boolean
  sx?: object
  variant?: 'contained' | 'outlined' | 'text'
}

export const InsightButton: React.FC<InsightButtonProps> = ({
  beat,
  disabled = false,
  hide = false,
  onClick,
  primary = true,
  sx,
  variant = !primary && 'text',
  ...rest
}) => {
  if (hide) return null

  return (
    <Button
      disabled={disabled}
      fullWidth={true}
      id={primary ? `primary-cta-${beat.guid}` : `secondary-cta-${beat.guid}`}
      onClick={onClick}
      sx={() => ({
        color: primary ? 'primary.main' : 'text.secondary',
        fontSize: primary ? 15 : 13,
        fontWeight: primary ? 600 : 700,
        p: '0px 16px',
        borderColor: 'neutral.light',
        ...sx,
      })}
      variant={disabled && primary ? 'contained' : variant || 'outlined'}
      {...rest}
    >
      {primary ? beat.call_to_action : beat.supporting_action}
    </Button>
  )
}
